'use strict';

(function ($window, initEvent, init, sendEvent) {
    $window.addEventListener(initEvent, function () {
        return init($window, sendEvent);
    });
})(window, 'initialise-fixed-tabs', function ($window, sendEvent) {
    var tabItems = $window.document.querySelectorAll('.fixed-tabs-list-item');
    var tabList = $window.document.querySelector('.fixed-tabs-list');
    var parent = $window.document.querySelector('.fixed-tabs, [fixed-tabs]');
    var goneClass = 'tab-gone';
    var hiddenClass = 'tab-hidden';
    var intersectingClass = 'tabs-intersecting';

    sendEvent('add-intersection', {
        detail: {
            target: tabItems,
            callback: function callback(entry) {
                var id = entry.target.getAttribute('data-tab-index');
                var menu = parent.querySelector('.fixed-tabs-sub-menu');
                var subItem = menu.querySelector('[data-tab-index=\'' + id + '\']');
                var el = entry.target;

                tabItems.forEach(function (element) {
                    return element.classList.remove('tab-last');
                });

                el.classList.toggle(hiddenClass, !entry.isInView);
                subItem.closest('li').classList.toggle(goneClass, entry.isInView);

                var nonHiddenTabs = tabList.querySelectorAll('.fixed-tabs-list-item:not(.tab-hidden)');
                var hiddenTabs = tabList.querySelectorAll('.fixed-tabs-list-item.tab-hidden');

                if (hiddenTabs.length >= 1 && nonHiddenTabs.length >= 1) nonHiddenTabs[nonHiddenTabs.length - 1].classList.add('tab-last');

                var showMore = parent.querySelectorAll('.' + goneClass);

                if (showMore.length != tabItems.length) parent.classList.add(intersectingClass);else parent.classList.remove(intersectingClass);
            },
            options: {
                root: parent,
                rootMargin: '0px',
                threshold: 0.99
            }
        }
    });
}, function (eventName, eventValue) {
    var event = void 0;

    if (typeof Event === 'function') {
        event = new CustomEvent(eventName, eventValue);
    } else {
        event = window.document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, eventValue);
    }

    window.dispatchEvent(event);
});